import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

import HeaderWrapper from '../../components/Header/wrapper'
import FooterWrapper from '../../components/Footer/wrapper'
import ArticleDetailWrapper from '../../components/ArticleDetail/wrapper'
import Breadcrumb from '../../components/Breadcrumb'
import usePWAInstallPrompt from '../../hooks/usePWAInstallPrompt'

import styles from './styles'


const useStyles = createUseStyles(styles)

function ArticleTemplate(props) {
  usePWAInstallPrompt()

  const classes = useStyles(props)
  const { breadcrumb = [], data = null } = props

  return (
    <div className={classes.container}>
      <HeaderWrapper />
      <Breadcrumb
        entries={breadcrumb}
        className={classes.breadcrumb}
      />
      <ArticleDetailWrapper
        {...data}
      />
      <FooterWrapper />
    </div>
  )
}

ArticleTemplate.styles = styles

ArticleTemplate.propTypes = {
  // eslint-disable-next-line
  breadcrumb: PropTypes.array,
  classes: PropTypes.objectOf(PropTypes.string),
  data: PropTypes.shape(ArticleDetailWrapper.propTypes),
}

export default ArticleTemplate
